var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 8.33338L11.6654 5.00005M2.08203 17.9167L4.90234 17.6033C5.24691 17.5651 5.4192 17.5459 5.58024 17.4938C5.72311 17.4475 5.85907 17.3822 5.98444 17.2995C6.12574 17.2063 6.24832 17.0838 6.49347 16.8386L17.4987 5.83338C18.4192 4.91291 18.4192 3.42052 17.4987 2.50005C16.5782 1.57957 15.0859 1.57957 14.1654 2.50005L3.16014 13.5053C2.91499 13.7504 2.79241 13.873 2.69923 14.0143C2.61656 14.1397 2.55121 14.2756 2.50496 14.4185C2.45283 14.5795 2.43368 14.7518 2.3954 15.0964L2.08203 17.9167Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7685dde6e570d15fb36db797f5a54ad4.svg";
export { ForwardRef as ReactComponent };